import api from "../utils/api";

export default {
  namespaced: true,
  state: {
    upsells: [],
    upsellStats: {},
    recentOrders: []
  },
  mutations: {
    SET_UPSELLS: (state, payload) => {
      state.upsells = payload.upsells;
    },
    SET_UPSELL_STATS: (state, payload) => {
      state.upsellStats = payload.stats;
    },
    SET_RECENT_ORDERS: (state, payload) => {
      state.recentOrders = payload.orders;
    },
    ADD_UPSELL: (state, upsell) => {
      state.upsells.push(upsell);
    },
    UPDATE_UPSELL: (state, updatedUpsell) => {
      const index = state.upsells.findIndex(
        upsell => upsell.id === updatedUpsell.id
      );
      if (index !== -1) {
        state.upsells.splice(index, 1, updatedUpsell);
      }
    },
    DELETE_UPSELL: (state, upsellId) => {
      state.upsells = state.upsells.filter(upsell => upsell.id !== upsellId);
    }
  },
  actions: {
    getUpsells(context) {
      return api.get(`upsell/list`).then(response => {
        context.commit("SET_UPSELLS", response);
        return response;
      });
    },
    getUpsellById(context, payload) {
      return api.get(`upsell/${payload.upsellId}`).then(response => {
        return response;
      });
    },
    createUpsell(context, payload) {
      return api.post(`upsell/list`, payload.requestParams).then(response => {
        if (response.success) {
          context.commit("ADD_UPSELL", response.upsell);
        }
        return response;
      });
    },
    getMessageLog(context, payload) {
      return api.get(`upsell/messagelog/?page=${payload.page}`);
    },
    updateStatus(context, payload) {
      return api.post(
        `upsell/status/${payload.upsellId}`,
        payload.requestParams
      );
    },
    getReport(context, payload) {
      return api.get(
        `upsell/report/?startDate=${payload.startDate}&endDate=${payload.endDate}&upsellId=${payload.upsellId}`
      );
    },
    getOrderReport(context, payload) {
      return api.get(
        `upsell/orderreport/?startDate=${payload.startDate}&endDate=${payload.endDate}&upsellId=${payload.upsellId}`
      );
    },
    getUploadUrl(context, payload) {
      return api.post(`upsell/upload`, payload.requestParams);
    },
    getTemplates() {
      return api.get(`upsell/templates`);
    },
    getScheduledMessages(context, payload) {
      return api.get(`upsell/scheduled/?page=${payload.page}`);
    },
    updateUpsell(context, payload) {
      return api
        .put(`upsell/${payload.upsellId}`, payload.requestParams)
        .then(response => {
          if (response.success) {
            context.commit("UPDATE_UPSELL", response.upsell);
          }
          return response;
        });
    },
    deleteUpsell(context, payload) {
      return api.delete(`upsell/${payload.upsellId}`).then(response => {
        if (response.success) {
          context.commit("DELETE_UPSELL", payload.upsellId);
        }
        return response;
      });
    },
    toggleUpsellStatus(context, payload) {
      return api
        .patch(`upsell/${payload.upsellId}/status`, payload.requestParams)
        .then(response => {
          if (response.success) {
            context.commit("UPDATE_UPSELL", response.upsell);
          }
          return response;
        });
    },
    duplicateUpsell(context, payload) {
      return api
        .post(`upsell/${payload.upsellId}/duplicate`, payload.requestParams)
        .then(response => {
          if (response.success) {
            context.commit("ADD_UPSELL", response.upsell);
          }
          return response;
        });
    },
    getUpsellStats(context, payload) {
      return api.get(`upsell/${payload.upsellId}/stats`).then(response => {
        context.commit("SET_UPSELL_STATS", response);
        return response;
      });
    },
    getUpsellOrders(context, payload) {
      return api
        .get(`upsell/${payload.upsellId}/orders?page=${payload.page || 1}`)
        .then(response => {
          context.commit("SET_RECENT_ORDERS", response);
          return response;
        });
    },
    exportUpsellData(context, payload) {
      return api.get(`upsell/${payload.upsellId}/export`, {
        responseType: "blob"
      });
    }
  },
  getters: {
    getUpsells: state => state.upsells,
    getUpsellStats: state => state.upsellStats,
    getRecentOrders: state => state.recentOrders,
    getActiveUpsells: state =>
      state.upsells.filter(upsell => upsell.status === "active"),
    getUpsellById: state => id => {
      return state.upsells.find(upsell => upsell.id === id);
    }
  }
};
